import React from 'react';
import Link from 'gatsby-link';
import scrollToPlugin from 'gsap/ScrollToPlugin';

import './header.scss';
import PhoneSvg from '../svg/phone';
import JpElectricSvg from '../svg/jp_electric';

const MenuItem = props => {
  const menuItemClick = (e) => {
    e.preventDefault();
    const el = document.getElementById(props.target);

    TweenLite.to(window, .8, {
      scrollTo: {y: el},
      ease: Power2.easeOut
    });

    props.clickHandler();
  };

  return (
    <a href="#" onClick={menuItemClick}>{props.children}</a>
  );
};

class Header extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      navOpen: false
    }

    this.toggleNav = this.toggleNav.bind(this);
    this.menuItemClick = this.menuItemClick.bind(this);
  }

  componentDidMount() {
    const Headroom = require('../../assets/js/headroom.min');
    this.headroom = new Headroom(this.refs.headroom, {
      offset: 50
    });
    this.headroom.init();

    const ScrollMagic = require('ScrollMagic');
    require('animation.gsap');
    require('TweenMax');

    this.controller = new ScrollMagic.Controller();
    
    new ScrollMagic.Scene({
      triggerElement: '.header'
    })
      .setTween(TweenMax.staggerFromTo('.header nav a', 1, {top: '-100px'}, {top: 0, delay: 0.5, ease: Back.easeInOut}, 0.2))
      .reverse(false)
      .addTo(this.controller);
  }

  componentWillUnmount() {
    this.headroom.destroy();
    this.controller.destroy();
  }

  toggleNav() {
    this.setState({
      navOpen: !this.state.navOpen
    });
  }

  menuItemClick() {
    this.setState({
      navOpen: false
    });
  }

  render() {
    const navClass = this.state.navOpen ? 'nav-open' : 'nav-closed';
    return (
      <div className="header tk-aktiv-grotesk">
        <div className="headroom" ref="headroom">
          <div className="container page-padding">
            <h1 className="logo">
              <Link to="/">
                <JpElectricSvg />
              </Link>
            </h1>
            <nav className={navClass}>
              <MenuItem target="about" clickHandler={this.menuItemClick}>About</MenuItem>
              <MenuItem target="past-work" clickHandler={this.menuItemClick}>Past Work</MenuItem>
              <MenuItem target="contact" clickHandler={this.menuItemClick}>Contact</MenuItem>
            </nav>
            <div className="phone">
              <a href="tel:9062289478">
                <PhoneSvg className="phone-icon" /> (906) 228-9478
              </a>
            </div>
            <div className={"hamburger " + navClass} onClick={this.toggleNav}>
              <div>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js